export const ITEMS = [
  {
    id: 1,
    title: 'Разместите свое первое объявление на Циан',
    stepClass: 'step-one',
    imageClass: 'button-img',
  },
  {
    id: 2,
    title: 'Включите и выберите продвижение на последнем этапе подачи объявления',
    stepClass: 'step-two',
    imageClass: 'vas-img',
  },
  {
    id: 3,
    title: '1 бонус = 1 рубль',
    stepClass: 'step-third',
    imageClass: 'coin-img',
  },
  {
    id: 4,
    title: 'Чем сильнее продвижение, тем больше потенциальных клиентов увидит ваше объявление',
    stepClass: 'step-fourth',
    imageClass: 'advert-img',
  },
];
